/*
 * @Description:
 * @Author: Teemo D
 * @Date: 2021-03-29 14:42:59
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-29 15:29:40
 * @FilePath:/unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/Preview/policyPage.tsx
 */
import React from 'react';

import { PageHeader, Policy } from 'unifyxp-ecomm-components';

import styles from './style.module.less';

import { PolicyType } from '../common';
interface Props {
  policy: PolicyType[];
}

function PolicyPage({ policy }: Props) {
  return (
    <div className={styles.policyContainer}>
      <PageHeader title='相关政策' />
      <div className={styles.policy}>
        {policy.map((item, index) => (
          <Policy key={index} title={item.title} />
        ))}
      </div>
    </div>
  );
}

export default PolicyPage;
